<template>
  <div>
    <ClientOnly>
      <RevChip
        v-model="isActive"
        class="tabular-nums"
        :is-loading="!isClientSide"
        :label="formattedLabel ?? ''"
        size="small"
        :start-icon="unref(fetchedIcon)"
      />

      <template #fallback>
        <RevChip
          v-model="isActive"
          :is-loading="!isClientSide"
          :label="saleEndDate ? `${label} 00:00:00:00` : label"
          size="small"
          :start-icon="unref(fetchedIcon)"
        />
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, unref } from 'vue'

import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevChip } from '@ds/components/Chip'
import { useCountdown } from '@ds/components/Counter/useCountdown'

import { useLoadIcon } from '../DynamicIcon/helpers/useLoadIcon'

const {
  saleEndDate,
  label,
  icon = '',
} = defineProps<{
  saleEndDate?: Maybe<string>
  label: string
  icon?: string
}>()

const isActive = defineModel<boolean>()
const fetchedIcon = await useLoadIcon(icon)
const isClientSide = ref(false)

onMounted(() => {
  isClientSide.value = true
})

const countdownParams = computed(() => ({
  date: new Date(saleEndDate ?? ''),
  maxUnit: 'days' as const,
  labels: { weeks: '', days: '', hours: '', minutes: '', seconds: '' },
}))

const countdown =
  import.meta.client && saleEndDate ? useCountdown(countdownParams) : undefined

const formattedLabel = computed(() => {
  if (!saleEndDate || !countdown?.value) return label

  const time = countdown.value.reduce((acc, item, index, array) => {
    return `${acc + item.value}${index !== array.length - 1 ? ':' : ''}`
  }, '')

  return `${label} ${time}`
})
</script>
